module.exports = __webpack_public_path__ + "static/media/undo-icon.fd9dfeef.svg";